import Model from '@/store/model';

class Product extends Model {
  map(json) {
    super.map(json);
  }

  originalPrice() {
    return this.originalMonthlyPrice() * this.renewMonthPeriod;
  }

  originalMonthlyPrice() {
    return 11.99;
  }

  discountPrice() {
    return this.price;
  }

  monthlyPrice() {
    return this.price / this.renewMonthPeriod;
  }

  discountMultiplierMonthlyPrice() {
    if (this.discountPercentage) {
      return ((100 - this.discountPercentage) / 100);
    }

    return 1;
  }

  formattedMonthlyPrice() {
    return `${(this.monthlyPrice()).toFixed(2)}`;
  }

  formattedOriginalMonthlyPrice() {
    return `${this.originalMonthlyPrice()}`;
  }

  formattedPrice() {
    return `${this.price}`;
  }

  formattedOriginalPrice() {
    return `${(this.originalPrice()).toFixed(2)}`;
  }

  formattedDiscountPrice() {
    return `${(this.discountPrice())}`;
  }

  formattedCurrency() {
    return `${this.currencyIsoCode}`;
  }

  displayPrice() {
    return `${this.formattedPrice()} ${this.formattedCurrency()}`;
  }

  displayPriceValue() {
    return `${this.formattedPrice()}`;
  }

  displayPriceWithParenthesis() {
    return `(${this.displayPrice()})`;
  }

  displayOriginalPrice() {
    return `${this.formattedOriginalPrice()} ${this.formattedCurrency()}`;
  }

  displayDiscountPrice() {
    return `${this.formattedDiscountPrice()} ${this.formattedCurrency()}`;
  }

  displayMonthlyPrice() {
    return `${this.formattedMonthlyPrice()} ${this.formattedCurrency()}`;
  }

  displayMonthlyPriceWithParenthesis() {
    return `(${this.formattedMonthlyPrice()} ${this.formattedCurrency()})`;
  }

  displayMonthlyPriceValue() {
    return `${this.formattedMonthlyPrice()}`;
  }


  displayOriginalMonthlyPrice() {
    return `${this.formattedOriginalMonthlyPrice()} ${this.formattedCurrency()}`;
  }

  payButtonText(trialText, payText, monthlyText) {
    if (this.hasTrialPeriod) {
      return trialText;
    }

    return `${this.displayPrice()} ${payText} ${this.renewMonthPeriod} ${monthlyText}`;
  }
}
export default Product;
